import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

interface LabelsObject {
  [key: string]: string;
}

interface LabelEntry {
  key: string;
  value: string;
}

const labelsToEntries = (labels: LabelsObject | null): LabelEntry[] => {
  if (!labels || typeof labels !== 'object') {
    return [];
  }
  return Object.entries(labels).map(([key, value]) => ({ key, value }));
};

const LabelsChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as LabelsObject | null;
  const newValue = change.newValue as LabelsObject | null;

  const oldLabels = labelsToEntries(oldValue);
  const newLabels = labelsToEntries(newValue);

  const added = newLabels.filter(n => !oldLabels.find(o => o.key === n.key));
  const removed = oldLabels.filter(o => !newLabels.find(n => n.key === o.key));
  const updated = newLabels.filter(n => {
    const old = oldLabels.find(o => o.key === n.key);
    return old && old.value !== n.value;
  });

  return (
    <>
      {added.length > 0 && (
        <ActivityItem.Section label="Added labels">
          {added.map(label => (
            <ActivityTagItem
              key={label.key}
              tagLabel={label.key}
              newValue={label.value}
            />
          ))}
        </ActivityItem.Section>
      )}

      {removed.length > 0 && (
        <ActivityItem.Section label="Removed labels">
          {removed.map(label => (
            <ActivityTagItem
              key={label.key}
              tagLabel={label.key}
              oldValue={label.value}
            />
          ))}
        </ActivityItem.Section>
      )}

      {updated.length > 0 && (
        <ActivityItem.Section label="Updated labels">
          {updated.map(label => {
            const old = oldLabels.find(o => o.key === label.key);
            return (
              <ActivityTagItem
                key={label.key}
                tagLabel={label.key}
                oldValue={old?.value}
                newValue={label.value}
              />
            );
          })}
        </ActivityItem.Section>
      )}
    </>
  );
};

export const METRIC_LABELS_CHANGE_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-labels-change',
    predicate: ({ change }) => change.fieldPath === '/labels',
    render: LabelsChangeRender,
  });
